import { FaqSchemaItem, toFaqList } from '../../builders/faq'

export const pdmPmmFaqItems: FaqSchemaItem[] = [
  {
    question: 'PdMやPMMが社内にいないのですが、導入できますか？',
    answer: 'はい、ゼロからの立ち上げ支援、ロール設計、業務定義から伴走いたします。',
  },
  {
    question: 'GTM戦略だけ、またはKPI設計だけでも依頼可能ですか？',
    answer: '可能です。特定領域へのスポット支援や戦略レビューのみのご依頼にも柔軟に対応します。',
  },
  {
    question: 'PMM体制を作っても社内に定着しないのではと不安です。',
    answer: '定着に必要なプロセス・会議体・ドキュメント設計まで支援し、ナレッジ移転と自走を実現します。',
  },
  {
    question: '複数部門が関わる大規模なプロダクトでも対応可能ですか？',
    answer: 'はい、開発・営業・マーケ・CSなど複数チームをまたぐ連携支援に多数の実績があります。',
  },
]

export const pdmPmmFaqList = toFaqList('よくあるご質問', '', pdmPmmFaqItems)
